import { ChevronBackIc } from '@dsch/dd-icons';

import * as Styled from './StepNavigation.styled';

type StepNavigationProps = {
  onBack?: () => void;
  onNext: () => void;
  showBack?: boolean;
  isSubmitting?: boolean;
  nextLabel?: string;
};

const StepNavigation = ({
  onBack,
  onNext,
  showBack = true,
  isSubmitting = false,
  nextLabel = 'Next',
}: StepNavigationProps) => {
  return (
    <Styled.Container>
      {showBack && onBack ? (
        <Styled.BackButton type="button" onClick={onBack} aria-label="Go back">
          <ChevronBackIc aria-hidden />
          Back
        </Styled.BackButton>
      ) : (
        <span />
      )}
      <Styled.NextButton
        type="button"
        onClick={onNext}
        disabled={isSubmitting}
        size="GROW"
      >
        {nextLabel}
      </Styled.NextButton>
    </Styled.Container>
  );
};

export { StepNavigation };
